export const REQUIRED_COOKIES = ["Tango-ST", "Tango-RT"];

export const getHasSessionCookies = () =>
  REQUIRED_COOKIES.every((name) =>
    document.cookie.split("; ").some((c) => c.startsWith(`${name}=`))
  );
